import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CriminalRecordCheckState } from '@state';

export const selectCriminalRecordCheckState =
  createFeatureSelector<CriminalRecordCheckState>('criminalRecordCheck');

export const selectCriminalRecordCheckDocument = createSelector(
  selectCriminalRecordCheckState,
  (state: CriminalRecordCheckState) => {
    return state.criminalRecordCheckDocument;
  }
);

export const selectCriminalRecordCheckDocumentFetchedAt = createSelector(
  selectCriminalRecordCheckState,
  (state: CriminalRecordCheckState) => state.fetchedAt
);
